module.exports = __webpack_public_path__ + "img/ygy.55940501.png";